import moment from "moment-timezone";
import { computed, ref } from "vue";
import { useStore } from "vuex";
import { customDateFormatWithTimezone } from "@/lib/helpers";

export interface Timeslot {
  arrival_window_end: string;
  arrival_window_start: string;
  disabled: boolean;
  scheduled_time: string;
}

export const useAppointmentAvailability = () => {
  const store = useStore();

  const selectedTimeSlot = ref<Timeslot | null>(null);

  const disabledDates = ref<Date[]>([]);
  const timeSlots = ref<Timeslot[]>([]);
  const queriedMonths = ref<Date[]>([]);
  const loadingTimeSlots = ref(false);
  const viewAllTimes = ref(false);

  const selectTimeSlot = (timeslot: Timeslot) => {
    selectedTimeSlot.value = timeslot;
  };
  const getMonthAvailability = async (data: {
    month: Date;
    serviceCategoryId: number;
    durationMinutes: number;
    userId?: number;
    zipcode: string;
  }) => {
    // cache month requests
    if (!queriedMonths.value.includes(data.month)) {
      queriedMonths.value.push(data.month);
      const res = await store.dispatch("fetchMonthAvailability", {
        service_date: data.month,
        service_category_id: data.serviceCategoryId,
        duration_minutes: data.durationMinutes,
        user_id: data.userId,
        postal_code: data.zipcode
      });
      const dates = Object.keys(res.data)
        .filter((date) => !res.data[date])
        .map((date) => moment(date).toDate());
      disabledDates.value = disabledDates.value.concat(dates);
    }
  };
  const getDateTimeSlots = async (data: {
    date: Date;
    serviceCategoryId: number;
    durationMinutes: number;
    userId?: number;
    zipcode: string;
  }) => {
    loadingTimeSlots.value = true;
    const res = await store.dispatch("fetchTimeSlots", {
      service_date: data.date,
      service_category_id: data.serviceCategoryId,
      duration_minutes: data.durationMinutes,
      user_id: data.userId,
      postal_code: data.zipcode,
      all_hours: true
    });
    timeSlots.value = res.data;
    loadingTimeSlots.value = false;
  };
  const isPast = (date: string) => moment(date).isBefore(moment());
  const getTimeSlotLabel = (timeslot: Timeslot) => {
    return `${customDateFormatWithTimezone(
      timeslot.arrival_window_start,
      "ha"
    )} - ${customDateFormatWithTimezone(timeslot.arrival_window_end, "ha")}`;
  };
  const visibleSlots = computed<Timeslot[]>(() => {
    if (viewAllTimes.value) return timeSlots.value;
    return timeSlots.value.filter((timeslot: Timeslot) => {
      return (
        moment(timeslot.arrival_window_start).hour() > 4 &&
        moment(timeslot.arrival_window_start).hour() < 20
      );
    });
  });
  return {
    disabledDates,
    timeSlots,
    visibleSlots,
    getTimeSlotLabel,
    selectTimeSlot,
    selectedTimeSlot,
    isPast,
    getMonthAvailability,
    getDateTimeSlots
  };
};
